export default [
  {
    value: 'title',
    text: 'Заголовок',
    type: 'string',
    description: ''
  },
  {
    value: 'status',
    text: 'Статус',
    width: 140,
    type: 'text',
    description: ''
  },
  {
    value: 'slug',
    text: 'Уникальное имя для URL',
    width: 190,
    type: 'string',
    description: ''
  },
  {
    value: 'copySlug',
    text: 'Скопировать',
    width: 40,
    align: 'end',
    type: 'actions',
    sortable: false,
    description: ''
  },
  {
    value: 'closestTimeSlot',
    text: 'Дата события',
    width: 160,
    type: 'date',
    description: ''
  },
  {
    value: 'primaryCategory.title',
    text: 'Категория',
    width: 100,
    type: 'string',
    description: ''
  },
  {
    value: 'translations',
    text: 'Языки',
    width: 40,
    type: 'string',
    sortable: false,
    description: ''
  },
  {
    text: 'Создано',
    value: 'createdAt',
    width: 180,
    type: 'date',
    description: ''
  },
  {
    text: 'Изменено',
    value: 'updatedAt',
    width: 180,
    type: 'date',
    description: ''
  },
  {
    text: 'Сортировка',
    value: 'sortOrder',
    width: 120,
    type: 'string',
    description: ''
  },
  {
    value: 'actions',
    text: 'Действия',
    width: 105,
    align: 'end',
    type: 'actions',
    sortable: false,
    description: ''
  }
]
